import { useWidgetContext } from "./context";
import { widgetDefinitions } from "./definitions";

export const WidgetManager = () => {
    const { layouts, addOrShowWidget, hideWidget } = useWidgetContext();

    if (!layouts) return null;

    const handleToggleWidget = (
        isEnabled: boolean,
        widgetId: string | undefined,
        definitionId: string
    ) => {
        if (isEnabled && widgetId) {
            hideWidget(widgetId);
            return;
        }

        addOrShowWidget(definitionId);
    }

    return (
        <section className="settings-section widget-manager">
            <h6>Manage Widgets</h6>
            <p className="text-muted small mb-3">
                Add widgets to your dashboard or hide ones you don't need.
            </p>

            <ul className="widget-manager__list list-unstyled mb-0">
                {widgetDefinitions.map((def) => {

                    const instances = layouts.widgets.filter((w) => w.definitionId === def.id);
                    const visibleWidget = instances.find((w) => w.isVisible !== false);
                    const isEnabled = !!visibleWidget;

                    return (
                        <li key={def.id} className="widget-manager__item">
                            <div className="widget-manager__info">
                                <div className="widget-manager__text">
                                    <div className="widget-manager__title-row">
                                        <span className="widget-manager__icon" aria-hidden="true">
                                            <i className={def.icon || "bi bi-grid-3x3-gap"} />
                                        </span>
                                        <span className="widget-manager__title">{def.title}</span>
                                    </div>
                                    {def.description && (
                                        <p className="widget-manager__desc text-muted small mb-0">{def.description}</p>
                                    )}
                                </div>
                            </div>

                            <div className="widget-manager__actions">
                                <div className="form-check form-switch mb-0">
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        role="switch"
                                        id={`widget-toggle-${def.id}`}
                                        checked={isEnabled}
                                        onChange={() => handleToggleWidget(isEnabled,visibleWidget?.widgetId,def.id) }
                                    />  
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>

        </section>
    );
};